<template>
  <div class="flex flex-row items-center gap-4" data-avatar-shape="square">
    <UserAvatar
      :user-id="user.id"
      size="large"
      :blink-icon="blinkIcon"
      :blink-icon-enabled="!!blinkIcon"
      :disponibility="user.disponibility?.assignement_status"
      hide-status
      flat
    />
    <div class="flex-1">
      <h3 class="text-base leading-none font-bold">
        {{ user.full_name }}
      </h3>
      <span
        v-if="assignedFuntion"
        :data-tint="assignedFuntion.tint"
        class="bg-primary text-contrast-primary rounded px-1 text-xs empty:hidden"
      >
        {{ assignedFuntion?.name ?? '' }}
      </span>
      <div v-if="hasOccupations">
        <div v-for="event in occupations" :key="event.id">
          {{ event.title }}
        </div>
      </div>
      <div v-if="hasAvailabilityItems" class="flex w-full flex-col">
        <table class="border-separate border-spacing-y-1.5">
          <tbody>
            <AvailabilityItem
              v-for="(availabilityItem, key) in localAvailabilityItems"
              :key="key"
              :item="availabilityItem"
            />
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="editionMode" class="shrink-0">
      <BaseDropDownMenu size="small" :options="actionMenuOptions" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import BaseDropDownMenu from '@c/addf-package/components/dropdown/BaseDropDownMenu.vue'
import UserAvatar from '@c/Avatar/UserAvatar.vue'
import { mapActions, mapGetters } from 'vuex'
import AvailabilityItem from '@c/Dashboard/Content/Planning/components/AvailabilityItem.vue'

export default defineComponent({
  name: 'SelectedEventUser',
  components: { AvailabilityItem, UserAvatar, BaseDropDownMenu },
  props: {
    user: {
      type: Object,
      required: true
    },
    eventId: {
      type: String,
      required: true
    },
    editionMode: {
      type: Boolean,
      required: false,
      default: false
    },
    occupations: {
      type: Array,
      required: false,
      default: () => []
    },
    allUsersAvailabilityItems: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  emits: ['updated'],
  computed: {
    ...mapGetters({
      assignedPersonFunctions: 'metadata/getAssignedPersonFunctionsMetadata',
      assignementStatuses: 'metadata/getAssignmentStatusMetadata'
    }),
    hasOccupations() {
      return Array.isArray(this.occupations) && this.occupations.length > 0
    },
    hasAvailabilityItems() {
      return this.localAvailabilityItems.length > 0
    },
    localAvailabilityItems() {
      return this.allUsersAvailabilityItems.filter(
        (availabilityItem) => availabilityItem.model_id === this.user.id
      )
    },
    assignedFuntion() {
      return this.assignedPersonFunctions.find(
        (assignedPersonFunction) =>
          this.user.disponibility.function === assignedPersonFunction.id
      )
    },
    blinkIcon() {
      return (
        this.assignedPersonFunctions.find(
          (assignedPersonFunction) =>
            assignedPersonFunction.id === this.user.disponibility?.function
        )?.icon ?? null
      )
    },
    actionMenuOptions() {
      return [
        this.assignementStatuses.map((assignementStatus) => {
          return {
            label: assignementStatus.name,
            icon: assignementStatus.icon ?? 'user',
            gate: true,
            tint: assignementStatus.bg_color,
            bg_color:
              this.user.disponibility.assignement_status ===
              assignementStatus.id
                ? 'bg-primary'
                : 'bg-white',
            txt_color:
              this.user.disponibility.assignement_status ===
              assignementStatus.id
                ? 'text-contrast-primary'
                : 'text-primary',
            action: () => this.updateAssignementStatus(assignementStatus.id)
          }
        }),
        this.assignedPersonFunctions.map((assignedPersonFunction) => {
          return {
            label: assignedPersonFunction.name,
            icon: assignedPersonFunction.icon ?? 'user',
            gate: true,
            tint: assignedPersonFunction.tint,
            bg_color:
              this.user.disponibility.function === assignedPersonFunction.id
                ? 'bg-primary'
                : 'bg-white',
            txt_color:
              this.user.disponibility.function === assignedPersonFunction.id
                ? 'text-contrast-primary'
                : 'text-primary',
            action: () => this.updateFunction(assignedPersonFunction.id)
          }
        }),
        [
          {
            label: this.$t('button.delete'),
            icon: 'trash',
            gate: true,
            bg_color: 'bg-red-500',
            txt_color: 'text-white',
            action: () => this.removeAssignedPeople()
          }
        ]
      ]
    }
  },
  methods: {
    ...mapActions({
      processUpdateAssignedPersonAction: 'planning/updateAssignedPerson',
      processRemoveAssignedPersonAction: 'planning/removeAssignedPerson'
    }),
    updateFunction(function_id) {
      this.updateAssignedPerson({
        ['function']: function_id
      })
    },
    updateAssignementStatus(assignement_status_id) {
      this.updateAssignedPerson({
        ['assignement_status']: assignement_status_id
      })
    },
    updateAssignedPerson(data) {
      this.processUpdateAssignedPersonAction({
        event_id: this.eventId,
        user_id: this.user.disponibility.id,
        data: {
          ...this.user.disponibility,
          ...data
        }
      }).then((response) => {
        this.$emit('updated')
      })
    },
    removeAssignedPeople() {
      this.processRemoveAssignedPersonAction({
        event_id: this.eventId,
        data: {
          assigned_users: [this.user.disponibility.id]
        }
      }).then((response) => {
        this.$emit('updated')
      })
    }
  }
})
</script>

<style scoped></style>
